<template>
  <div>
    <div class="contact__container">
      <div class="contact__column">
        <div class="contact__section contact__section--contact">
          <div class="contact__item contact__item--email">
            <h3 class="contact__heading">Email:</h3>
            <ul class="contact__list">
              <li
                v-for="email in emails"
                :key="email"
                class="contact__list-item"
              >
                <a
                  :href="`mailto:${email}`"
                  class="contact__link"
                  v-text="email"
                />
              </li>
            </ul>
          </div>
          <div class="contact__item contact__item--phone">
            <h3 class="contact__heading">Phone:</h3>
            <ul class="contact__list">
              <li class="contact__list-item">
                <a
                  :href="phone | phoneUri"
                  class="contact__link"
                  v-text="phone"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <CourtHalf
      class="court contact__court"
      side="bottom"
    />
    <div class="contact__container">
      <UnltdBadgeGraphic class="contact__badge"/>
      <div class="contact__column">
        <div class="contact__section">
          <div class="contact__section--address">
            <h3 class="contact__heading">Locations:</h3>
            <div class="address__container">
              <div
                v-for="({ label, address }) in addresses"
                :key="label"
                class="contact__item"
              >
                <h4
                  class="contact__subheading"
                  v-text="label"
                />
                <address
                  class="contact__address"
                  v-html="address"
                />
                <a
                  :href="address | directionsUri"
                  class="contact__link"
                  target="_blank"
                >Get Directions</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CourtHalf
      class="court contact__court"
      side="top"
    />
  </div>
</template>

<script>
  import CourtHalf from './CourtHalf';
  import UnltdBadgeGraphic from './UnltdBadgeGraphic';

  export default {
    components: {
      CourtHalf,
      UnltdBadgeGraphic,
    },
    filters: {
      directionsUri(address) {
        return `https://www.google.com/maps/search/?api=1&query=${window.encodeURIComponent(address.replace(/<br \/>/g, ' '))}`;
      },
      phoneUri(phone) {
        return `tel:${phone}`;
      },
    },
    props: {
      emails: {
        type: Array,
        default: null,
      },
      phone: {
        type: String,
        default: null,
      },
      addresses: {
        type: Array,
        default: null,
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .contact__court {
    color: color(lightest-grey);
  }

  .contact__container {
    @include container;
    position: relative;
    padding-top: spacing(base-epsilon);
    padding-bottom: spacing(base-epsilon);

    @include breakpoint(phablet) {
      padding-top: spacing(base-zeta);
      padding-bottom: spacing(base-zeta)
    }
  }
  .contact__column {
    @include column;
  }

  .contact__section {
    position: relative;
    z-index: 1;
    display: flex;
    padding-left: spacing(base-gamma);
    border-left: 2px solid color(bronze);

    @include breakpoint(phablet) {
      padding-left: 0;
      margin-left: percentage(1/12);
      width: percentage(9/12);
      border-left: 0;
    }
  }

  .contact__section--contact {
    justify-content: space-between;
    flex-direction: column;

    @include breakpoint(phablet) {
      flex-direction: row;
    }
  }

  .address__container {
    display: flex;
    flex-direction: column;

    @include breakpoint(phablet) {
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
    }
  }

  .contact__heading,
  .contact__subheading,
  .contact__link,
  .contact__address {
    font-family: font-family(sans-serif);
  }

  .contact__heading {
    font-size: 1.7rem;
    color: color(red);

    @include breakpoint(phablet) {
      font-size: 2.6rem;
    }
  }

  .contact__heading,
  .contact__subheading {
    font-weight: font-weight(bold);
  }

  .contact__subheading {
    margin-top: spacing(base-delta);
    font-size: 1.3rem;
    color: color(blue);
    text-transform: uppercase;

    @include breakpoint(phablet) {
      margin-top: spacing(base-epsilon);
      font-size: 1.2rem;
    }
  }

  .contact__address {
    font-style: normal;
    line-height: 1.5;
    color: color(slate);
  }

  .contact__address,
  .contact__link {
    margin-top: spacing(base-gamma);
    font-size: 1.5rem;

    @include breakpoint(phablet) {
      margin-top: spacing(base-delta);
      font-size: 2rem;
    }
  }

  .contact__link {
    display: inline-block;
    padding-bottom: 2px;
    color: color(bronze);
    border-bottom: 2px solid color(bronze);
    transition-property: color border;
    transition-timing-function: timing-function(accelerate);
    transition-duration: duration(fast);

    &:focus,
    &:hover {
      color: color(red);
      border-bottom: 2px solid color(red);
      transition-timing-function: timing-function(decelerate);
    }
  }

  .contact__section--address {
    width: 100%;
  }

  .contact__item {

    @include breakpoint(phablet) {
      min-width: percentage(3/9);
    }
  }

  .contact__item--email,
  .contact__item--phone,
  .contact__section--address {

    @include breakpoint(phablet) {
      border-left: 2px solid color(bronze);
      padding-left: spacing(base-delta);
    }
  }

  .contact__item--phone {
    margin-top: spacing(base-delta);

    @include breakpoint(phablet) {
      margin-top: 0;
    }
  }

  .contact__list {
    margin-top: spacing(base-beta);

    @include breakpoint(phablet) {
      margin-top: spacing(base-gamma);
    }
  }

  .contact__badge {
    position: absolute;
    z-index: 0;
    left: 50%;
    top: 50%;
    width: 200px;
    fill: color(lightest-grey);
    transform: translate(10%, -50%);

    @include breakpoint(phablet) {
      width: 280px;
      transform: translate(-50%, -50%);
    }
  }
</style>
